import { defineMessages } from 'react-intl';

const messages = defineMessages({
  shipmentActivitySectionTitle: {
    defaultMessage: 'Shipment Activity',
    description: 'Order details Shipment Activity section header',
    id: 'cIhhFJ',
  },
  sectionAriaLabel: {
    defaultMessage: 'Shipment Activity expander section',
    description: 'Aria label for the expandable Shipment Activity section',
    id: '7z65k+',
  },
});

export default messages;
